<template>
  <div class="uk-container">
    <Modal v-model:isOpen="isCarrierDetailsOpen" modalId="carrier-details-modal" maxWidth="5xl" @close="closeCarrierDetails">
      <template #title>Carrier Details</template>
      <template #content>
        <CarrierDetailModal
          v-if="selectedBrokerCarrierAssociation"
          :brokerCarrierAssociation="selectedBrokerCarrierAssociation"
        ></CarrierDetailModal>
      </template>
    </Modal>
    <table
      class="uk-text-small uk-text-small uk-table-middle uk-table uk-table-condensed uk-table-small uk-table-divide uk-table-small uk-table-striped uk-table-justify uk-table-middle uk-table-hover"
    >
      <thead>
        <tr>
          <th class="uk-text-center uk-text-normal">Name</th>
          <th class="uk-text-bold uk-text-center">Number of Loads Carried</th>
          <th class="uk-text-center uk-text-bolder">Onboarding Status</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="brokerCarrierAssociation in brokerCarrierAssociations"
          :key="brokerCarrierAssociation.company2.id"
          v-on:click="selectCarrier(brokerCarrierAssociation.company2.id, $event)"
        >
          <td class="uk-text-center">
            <div>
              <b>{{ brokerCarrierAssociation.customCarrierName }}</b>
            </div>
          </td>

          <td class="uk-text-center">{{ 0 }}</td>
          <td class="uk-text-center">{{ brokerCarrierAssociation.onboardingStatus }}</td>
          <td v-if="brokerCarrierAssociation.onboardingStatus === 'NA'" class="uk-text-center">
            <button
              class="uk-button uk-button-large uk-button-primary uk-form-controls"
              v-on:click="startCarrierOnboarding(brokerCarrierAssociation.company2.id, $event)"
            >
              <!-- <div v-if="showAddNew"><span uk-icon="icon: minus"></span>Close</div>
              <div v-else><span uk-icon="icon: plus"></span>New Carrier</div> -->
              Start Onboarding
            </button>
          </td>
          <td v-else class="uk-text-center">
            <button
              class="uk-button uk-button-large uk-button-primary uk-form-controls uk-button-disabled"
              v-on:click="startCarrierOnboarding(brokerCarrierAssociation.company2.id)"
              disabled
            >
              <!-- <div v-if="showAddNew"><span uk-icon="icon: minus"></span>Close</div>
              <div v-else><span uk-icon="icon: plus"></span>New Carrier</div> -->
              Start Onboarding
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import CarrierDetailModal from './CarrierDetailModal.vue';
import Modal from '@/components/core/Modal/Modal.vue';
import StartCarrierOnboarding from '../../gql/onboarding/mutations/StartCarrierOnboarding.gql';
import CompanyCompanyAssociationCarriersQuery from '../../gql/onboarding/CompanyCompanyCarriers.gql';

export default defineComponent({
  name: 'CarrierTable',
  components: {
    CarrierDetailModal,
    Modal,
  },
  props: ['brokerCarrierAssociations'],
  data() {
    return {
      // selectedDriver: -1,
      loading: [],
      // showActiveOnly: true,
      startingOnboarding: false,
      selectedCarrierId: null as number | null,
    };
  },
  computed: {
    carriers() {
      const carriers = (this as any).brokerCarrierAssociations.map((x) => x.company2);
      return carriers;
    },
    selectedBrokerCarrierAssociation(): any {
      const vm = this as any;
      if (!vm.selectedCarrierId) return null;
      return (vm.brokerCarrierAssociations || []).find(
        (x: any) => x.company2?.id === vm.selectedCarrierId,
      ) || null;
    },
    isCarrierDetailsOpen: {
      get(): boolean {
        return (this as any).selectedCarrierId !== null;
      },
      set(value: boolean) {
        if (!value) {
          (this as any).closeCarrierDetails();
        }
      },
    },
  },
  methods: {
    selectCarrier(idx: number, event: any) {
      const vm = (this as any);

      if (event) {
        event.preventDefault();
      }

      if (vm.startingOnboarding) {
        return;
      }
      vm.selectedCarrierId = idx;
    },
    closeCarrierDetails() {
      (this as any).selectedCarrierId = null;
    },
    startCarrierOnboarding(idx: number, event?: any) {
      const vm = (this as any);

      if (event) {
        event.preventDefault();
      }

      vm.startingOnboarding = true;

      console.log('IDX ini startCarrierOnboarding', idx);
      vm.$apollo
        .mutate({
          mutation: StartCarrierOnboarding,
          variables: {
            carrierId: idx,
          },
          update: (store, { data }) => {
            console.log('UPDATE: ', data);
            let companyCompanyAssociationCarriers = (store.readQuery({
              query: CompanyCompanyAssociationCarriersQuery,
            }) as any).companyCompanyAssociationCarriers;

            console.log('[mut] query store data: ', companyCompanyAssociationCarriers);
            const newAssociation = data.startCarrierOnboarding.brokerCarrierAssociation;
            console.log('[mut] new assoc: ', newAssociation);
            companyCompanyAssociationCarriers = companyCompanyAssociationCarriers.filter(
              (x) => x.company2.id !== newAssociation.company2.id,
            );
            companyCompanyAssociationCarriers.push(newAssociation);

            console.log('DATA IIS', data);
            store.writeQuery({
              query: CompanyCompanyAssociationCarriersQuery,
              data: {
                companyCompanyAssociationCarriers,
              },
            });
          },
        })
        // eslint-disable-next-line
        .then((data) => {
          vm.startingOnboarding = false;
          window.alert('Onboarding email sent to carrier!');
        })
        .catch((error) => {
          vm.startingOnboarding = false;
        });
    },
  },
});
</script>

<style lang="scss">
.uk-label-inactive {
  border: 1px solid black;
  background-color: #7b7b7b;
}
</style>
